import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import ContactUs from "./pages/ContactUs";
import Vehicle from "./pages/Vehicle";
import LiveBidPage from "./pages/LiveBidPage";
import Seller from "./components/Seller";
import Buyer from "./components/Buyer";
import UserMenu from "./components/user/UserMenu";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ProtectedRoute, PublicRoute } from "./components/ProtectedRoute";
import Auctions from "./components/Auctions";
import Search from "./pages/Search";
import BuyNowVehicles from "./pages/BuyNowVehicles";
import NotificationsPage from "./pages/NotificationsPage";
import InformationPage from "./pages/InformationPage";
import NotFound from "./pages/404";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<Layout />}>
              <Route index element={<Home />} />
              <Route path=':slug' element={<Vehicle />} />
              <Route path='vehicles' element={<Search />} />
              <Route path='buynow/vehicles' element={<BuyNowVehicles />} />
              {/* <Route path='auction' element={<Home />} /> */}
              <Route path='auctions' element={<Auctions />} />
              <Route path='buyer' element={<Buyer />} />
              <Route path='seller' element={<Seller />} />
              <Route path='contact' element={<ContactUs />} />
              <Route path='search' element={<Search />} />
              <Route path='content/:slug' element={<InformationPage />} />
              <Route
                path='livebid/:auctionId/:auctionLaneId'
                element={<LiveBidPage />}
              />
              <Route path='blog' element={<Blog />} />
              <Route path='blog/:slug' element={<BlogDetail />} />

              {/* Auth routes with Layout (Header + Footer) */}
              <Route
                path='login'
                element={
                  <PublicRoute>
                    <LoginPage />
                  </PublicRoute>
                }
              />
              <Route
                path='forgot-password'
                element={
                  <PublicRoute>
                    <ForgotPassword />
                  </PublicRoute>
                }
              />
              <Route
                path='reset-password'
                element={
                  <PublicRoute>
                    <ResetPassword />
                  </PublicRoute>
                }
              />
              <Route
                path='reset-password/:email'
                element={
                  <PublicRoute>
                    <ResetPassword />
                  </PublicRoute>
                }
              />
              <Route
                path='register'
                element={
                  <PublicRoute>
                    <SignUpPage />
                  </PublicRoute>
                }
              />

              {/* Unified Dashboard Routes - All use UserMenu */}
              <Route
                path='dashboard'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='profile'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='profile/changepassword'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='profile/documents'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />

              <Route
                path='mybids'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='wonvehicles'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='myvehicles'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='addvehicles'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='sales'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='deposit'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='payment'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='statement'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='historygatepass'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='tickets'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='wishlist'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='myplans'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='listingfee'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='withdrawalrequests'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='invoices'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='notifications'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path='review'
                element={
                  <ProtectedRoute>
                    <UserMenu />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* 404 Route - Catch all unmatched routes */}
            <Route path='*' element={<NotFound />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
